import { useEffect } from "react";

import { generateStaticPieNode } from "../../graph-util";
import { extractExtractedFilesPieChunks } from "../../utils";
import {
  CreateControlNodeOnlyFn,
  ExtractedFilesCountsDict
} from "../../@types";

interface Props {
  renderer: CreateControlNodeOnlyFn;
  counts: { pie: ExtractedFilesCountsDict; total: number };
}

const useRenderExtractedFilesRS = ({
  renderer: createControlNodeFromData,
  counts: { pie: extractedFilesCounts, total: extractedFilesTotalCount }
}: Props) => {
  useEffect(() => {
    if (!extractedFilesTotalCount || !extractedFilesCounts) return;
    createControlNodeFromData({
      generateControlNode: () =>
        generateStaticPieNode({
          id: "extractedFilesNode",
          label: "Extracted Files",
          ...extractExtractedFilesPieChunks(extractedFilesCounts),
          radius: 70,
          total: extractedFilesTotalCount
        })
    });
  }, [
    createControlNodeFromData,
    extractedFilesCounts,
    extractedFilesTotalCount
  ]);
};

export default useRenderExtractedFilesRS;
